import React from 'react';
import { Capacitor } from '@capacitor/core';
import { useLocalization } from '@/hooks/useLocalization';

interface DownloadOverlayProps {
  visible: boolean;
  onCancel?: () => void;
  text?: string;
}

export const DownloadOverlay: React.FC<DownloadOverlayProps> = ({
  visible,
  onCancel,
  text,
}) => {
  const { t } = useLocalization();
  if (!visible) return null;

  const isDownloading = text === 'Downloading...';

  const isNative = Capacitor.getPlatform() !== 'web';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: isNative ? 0 : 16,
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(0,0,0,0.8)',
          padding: isNative ? 0 : 20,
          borderRadius: isNative ? 0 : 8,
          minWidth: isNative ? '100%' : 200,
          width: isNative ? '100%' : undefined,
          height: isNative ? '100%' : undefined,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            width: 36,
            height: 36,
            animation: 'spin 1s linear infinite',
            margin: '0 auto 12px',
          }}
        />
        <div style={{ color: '#fff', fontSize: 16, fontWeight: 500 }}>
          {text}
        </div>
        {isDownloading && onCancel && (
          <button
            onClick={onCancel}
            style={{
              marginTop: 16,
              padding: '6px 16px',
              fontSize: 16,
              border: 'none',
              borderRadius: 6,
              backgroundColor: '#e74c3c',
              color: '#fff',
              cursor: 'pointer',
              minWidth: 120,
            }}
          >
            {t('cancel')}
          </button>
        )}
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
